import { type Address, erc20Abi } from "viem";
import { getClient } from "../lib/client";
import type { ChainId } from "./vault-config";

type AllowanceProps = {
  tokenAddress: Address;
  spenderAddress: Address;
  userAddress: Address;
  chainId: ChainId;
};

export async function getVaultAllowance({
  tokenAddress,
  spenderAddress,
  userAddress,
  chainId,
}: AllowanceProps): Promise<bigint> {
  const client = await getClient(chainId);
  const allowance = await client.readContract({
    abi: erc20Abi,
    address: tokenAddress,
    functionName: "allowance",
    args: [userAddress, spenderAddress],
  });

  return allowance;
}

type TotalSupplyProps = {
  tokenAddress: Address;
  chainId: ChainId;
};

export async function getTotalSupply({
  tokenAddress,
  chainId,
}: TotalSupplyProps): Promise<bigint> {
  const client = await getClient(chainId);
  const totalSupply = await client.readContract({
    abi: erc20Abi,
    address: tokenAddress,
    functionName: "totalSupply",
  });

  return totalSupply;
}
